import AppList from '../views/Mobile/AppList.vue';
import AppPush from '../views/Mobile/AppPush.vue';

let Mobile = [
  {
    path: 'AppList',
    name: '广告列表',
    component: AppList
  },
  {
    path: 'AppPush',
    name: '文章推送',
    component: AppPush
  },
];

export default Mobile;
